import React from "react";

const PreviewNavbar = ({ logo, title, theme }) => {
  const navbarStyle = {
    background: theme?.background || "#ffffff",
    color: theme?.textColor || "#333333",
    borderBottomColor: theme?.borderColor || "#e0e0e0",
  };

  return (
    <div className="preview-navbar" style={navbarStyle}>
      <div className="preview-navbar-left">
        {logo && <img src={logo} alt="logo" className="preview-logo" />}
        <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: theme?.textColor }}>
          {title || "Dashboard Preview"}
        </h2>
      </div>
    </div>
  );
};

export default PreviewNavbar;